<template>
    <div class="login-body">
        <div class="login-wrapper">
            <div class="login-panel">
                <router-link to="/" class="logo" id="pha-logo">
                    <img src="layout/images/PHA logo-white.png" alt="pha-logo" />
                </router-link>
                <ScaleLoader v-if="loader" />
                <div class="login-form">
                    <h3> Reset Password </h3>
                    <p>Please input your email to reset your password.</p>
                    <InputText maxlength = "255" type="email" v-model="userEmail" placeholder="Email" required="true" />
                    <Button label="Reset Password" type="button" @click.prevent="onResetPassword"></Button>
                    <Toast class="custom-toast" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import { showToast } from '@/helpers/toast-handler';
import { useRouter } from 'vue-router';

const router = useRouter();

const loader = ref(false);
const userEmail = ref('');

function onResetPassword() {
    GlobalRequest.getRequest('/v2/users/forgot-password', {
        params: {
            email: userEmail.value,
        },
    }).then(async (response) => {
        if (response.statusCode === 200) {
            await showToast({ summary: 'Success', severity: 'info' }, 'Password Reset link have been emailed').then(() => {
                setTimeout(() => {
                    router.push({ name: 'login' });
                }, 1000);
            });
        }
        else if (response.status === 400) { // Handle 400 inside else block
            showToast({ summary: 'Warning', severity: 'info' }, response.data.message || 'Something went wrong');
        } else {
            console.log(response.data, 'checking else for other errors');
        }
    })
}
</script>


<style scoped>
.login-body .login-wrapper .login-panel {
    justify-content: center;
}
.login-body .login-wrapper .login-panel .login-form {
    /* .row {
    display: flex;
    flex: wrap;
    margin: auto 2rem;
} */
    h3,
    .field-checkbox label {
        color: #c3ccdd;
    }
}
</style>